module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fotgotPwd"
  }, [_c('div', {
    staticClass: "top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "lines avlines"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "sort",
    class: {
      avbg: _vm.step == 2 || _vm.step == 3
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {}, [_vm._v("安全验证")])]), _vm._v(" "), _c('div', {
    staticClass: "lines",
    class: {
      avlines: _vm.step == 3
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "sort",
    class: {
      avbg: _vm.step == 3
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('p', {}, [_vm._v("重置密码")])])]), _vm._v(" "), (_vm.step == 1) ? _c('div', {
    staticClass: "step"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("手机号码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "input_filed",
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号码",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }, function($event) {
        _vm.avbtn(1)
      }]
    }
  }), _vm._v(" "), (_vm.mobile.length > 0) ? _c('span', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.del(1)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "button next",
    class: {
      avbg: _vm.av_step == 1
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")])]) : (_vm.step == 2) ? _c('div', {
    staticClass: "step"
  }, [_c('p', [_vm._v("我们已向您的手机" + _vm._s(_vm.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')) + "发送了一条6位数的验证码，请打开手机查收")]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("验证 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "verify",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }, function($event) {
        _vm.avbtn(2)
      }]
    }
  }), _vm._v(" "), (_vm.code.length > 0) ? _c('span', {
    staticClass: "delete",
    staticStyle: {
      "right": "430px"
    },
    on: {
      "click": function($event) {
        _vm.del(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button submit",
    class: {
      avbg: _vm.wait == 0
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("重新发送"), (_vm.wait != 0) ? _c('span', [_vm._v(_vm._s(_vm.wait) + "s")]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "button next",
    class: {
      avbg: _vm.av_step == 2
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")])]) : (_vm.step == 3) ? _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "password"
  }, [_c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("密码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input_filed",
    attrs: {
      "type": "password",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": _vm.confirm,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.password.length > 0) ? _c('span', {
    staticClass: "delete",
    staticStyle: {
      "right": "100px"
    },
    on: {
      "click": function($event) {
        _vm.del(1)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("确认密码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "input_filed",
    attrs: {
      "type": "password",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "blur": _vm.confirmPwd,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.confirmPassword.length > 0) ? _c('span', {
    staticClass: "delete",
    staticStyle: {
      "right": "100px"
    },
    on: {
      "click": function($event) {
        _vm.del(2)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "button next",
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendPwd
    }
  }, [_vm._v("完成")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sort avbg"
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "active"
  }, [_vm._v("确认账号")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-768e2223","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ForgotPwd.vue
// module id = 1221
// module chunks = 1